/*
 * -----------------------------------------------------------------------
 *  <copyright file="dialog-information-box.interface.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

export enum InfoBoxStyleClasses {
    green = 'green',
    amber = 'amber',
}

export enum InfoBoxIcons {
    'infoCircle' = 'info-circle',
    'exclamationTriangle' = 'exclamation-triangle',
}

export interface DialogInformationBoxProps {
    topText: string;
    bottomText?: string;
    boxStyleClass?: InfoBoxStyleClasses;
    icon?: InfoBoxIcons;
}
